// extracted by mini-css-extract-plugin
module.exports = {"config":"ConfigPanel_config__1oKaJ"};